// Per-hostname branding: ONE build serves several careers domains.
// The ONLY thing that changes per domain is the top-left logo — everything
// else (jobs shown, copy, theme) is identical.
//
// ?tenant=<key> overrides the hostname (handy for local dev / preview).

const TENANTS = {
  'jobs.calum.be': {
    key: 'calum',
    brand: 'Calum',
    logo: '/calum-logo.png',
    logoClass: 'h-9 w-auto rounded',
    primaryOrg: 'calum',   // this brand's jobs sort to the top of the board
  },
};

const DEFAULT_TENANT = {
  key: 'lamptwist',
  brand: 'LampTwist',
  logo: '/lamptwist-logo.svg',
  logoClass: 'h-6 w-auto sm:h-7',
  primaryOrg: 'lamptwist',
};

function resolveTenant() {
  if (typeof window === 'undefined') return DEFAULT_TENANT;
  const override = new URLSearchParams(window.location.search).get('tenant');
  if (override) {
    const match = Object.values(TENANTS).find((t) => t.key === override);
    if (match) return match;
  }
  return TENANTS[window.location.hostname] || DEFAULT_TENANT;
}

export const tenant = resolveTenant();
